module.exports = __webpack_public_path__ + "7e367be02cd17a96d513ab74846bafb3.woff2";